// RxJS
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPatientWeightsInStore,
  selectPatientWeightsPageLoading,
  selectPatientWeightsShowInitWaitingMessage,
} from '../_selectors/patient-weight.selectors';

export class PatientWeightsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPatientWeightsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPatientWeightsShowInitWaitingMessage));

    this.store
      .pipe(select(selectPatientWeightsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
